import { render } from "./TextMessage.vue?vue&type=template&id=52e5cf5e&scoped=true&ts=true"
import script from "./TextMessage.vue?vue&type=script&lang=ts"
export * from "./TextMessage.vue?vue&type=script&lang=ts"

import "./TextMessage.vue?vue&type=style&index=0&id=52e5cf5e&lang=scss&scoped=true"
import "./TextMessage.vue?vue&type=style&index=1&id=52e5cf5e&lang=scss"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5cf5e"]])

export default __exports__